import { render, staticRenderFns } from "./Pagadav.vue?vue&type=template&id=8c99305c&"
import script from "./Pagadav.vue?vue&type=script&lang=js&"
export * from "./Pagadav.vue?vue&type=script&lang=js&"
import style0 from "./Pagadav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports